import classNames from 'classnames';
import { ReactElement } from 'react';

import { CheckMarkIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { customScrollStyles } from '@gem/ui-kit';

import styles from './DropDownOptions.styles.m.css';
import { IDropDownOptionsProps } from './DropDownOptions.types';

export const DropDownOptions = (props: IDropDownOptionsProps): ReactElement => {
  const { onChange, onClose, value, options, noSelectedLabel } = props;
  const { t } = useTranslation();
  const listClass = classNames(styles.list, customScrollStyles.container);

  const handleChange = (id: string | null): void => {
    onClose();
    onChange(id);
  };

  const nameNoSelectedContainer = classNames(styles.name, {
    [styles.nameSelected]: !value,
  });

  return (
    <>
      <AddKeyPressHandler onEsc={onClose} />
      <div className={listClass}>
        <button
          className={styles.item}
          onClick={(): void => handleChange(null)}
        >
          <span className={styles.markContainer}>
            {!value && <CheckMarkIcon className={styles.mark} />}
          </span>
          <span className={nameNoSelectedContainer}>
            {t(noSelectedLabel || 'category_no_selected')}
          </span>
        </button>
        {options.map((option) => {
          const isSelected = value === option.value;

          const nameContainer = classNames(styles.name, {
            [styles.nameSelected]: isSelected,
          });

          return (
            <button
              key={option.value}
              className={styles.item}
              onClick={(): void => handleChange(option.value)}
            >
              <span className={styles.markContainer}>
                {isSelected && <CheckMarkIcon className={styles.mark} />}
              </span>
              <span className={nameContainer}>{option.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};
